import React from "react"
import CalculateAge from "../Calculator/SubCalculator/CalculateAge"
import CalculateOptions from "../Calculator/SubCalculator/CalculateOptions"
import CurrentExpenses from "../Calculator/Current/CurrentExpense"
import CalculatorStore from "../../Configs/Store/calculator"
import CalculatorButton from "../Common/CalculatorButton"
import { observer } from "mobx-react"

const DisabledNext = observer(function DisabledNext({ title, onClick, scrn }) {
  return <CalculatorButton title={title} onClick={onClick} scrn={scrn} disabled={CalculatorStore.isDisabled} />
})

const Calculator = observer((props) => {
  const screenNo = CalculatorStore.screenNo
  const showData = CalculatorStore.showData

  return (
    <>
      {screenNo === "Scr1" ? (
        <>
          <CalculateAge handleAgeVal={props.handleAgeVal} />
          <DisabledNext title={"Next"} onClick={props.handlenextbutton} scrn={"Scr2"} />
        </>
      ) : screenNo === "Scr2" ? (
        <>
          <CalculateOptions onClickFunction={props.onClickFunction} />
        </>
      ) : screenNo === "Scr3" ? (
        <>
          <CurrentExpenses
            id="0"
            keys="0"
            scrn="Scr3"
            handlenextbutton={props.handlenextbutton}
            handlecurrentExpenses={props.handlecurrentExpenses}
            handlecurrentExpenses_Accurate={props.handlecurrentExpenses_Accurate}
          />
          {showData === 0 && <DisabledNext title={"Next"} onClick={props.handlenextbutton} scrn={"Scr5"} />}
        </>
      ) : screenNo === "Scr4" ? (
        <>
          <CurrentExpenses
            id="1"
            keys="1"
            scrn="Scr4"
            handlenextbutton={props.handlenextbutton}
            handlecurrentExpenses={props.handlecurrentExpenses}
            handlecurrentExpenses_Accurate={props.handlecurrentExpenses_Accurate}
          />
          {showData === 0 && <DisabledNext title={"Next"} onClick={props.handlenextbutton} scrn={"Scr5"} />}
        </>
      ) : screenNo === "Scr5" ? (
        <>
          <CurrentExpenses
            id="2"
            keys="2"
            scrn="Scr5"
            handlenextbutton={props.handlenextbutton}
            handlecurrentExpenses={props.handlecurrentExpenses}
            handlecurrentExpenses_Accurate={props.handlecurrentExpenses_Accurate}
          />
          {showData === 0 && <DisabledNext title={"Next"} onClick={props.handlenextbutton} scrn={"Scr6"} />}
        </>
      ) : screenNo === "Scr6" ? (
        <>
          <CurrentExpenses id="3" keys="3" scrn="Scr6" />
          <CalculatorButton title={"Next"} onClick={props.handlenextbutton} scrn={"Scr7"} />
        </>
      ) : (
        <></>
      )}
    </>
  )
})

export default Calculator
